
































































import { mapActions, mapGetters } from 'vuex';

import { diffDeep, setErrorFromAxiosError } from '@/utils/helpers';
import mixins from '@/utils/mixins';
import authMixin from '@/mixins/auth';
import formRulesMixin from '@/mixins/file-upload-rules';

import {
  IQuoteDocumentTag,
  IQuoteDocumentTagData,
  QuoteDocumentTag
} from '@/models';
import { SystemError } from '@/models/error/error';
import { ISystemError } from '@/models/error/error.types';

import { ALForm } from '@/common/component.types';
import ALDialog from '../core/Dialog/ALDialog.vue';
import ErrorAlert from '@/components/common/ErrorAlert.vue';

const baseMixins = mixins(authMixin, formRulesMixin);

export interface Options extends InstanceType<typeof baseMixins> {
  $refs: {
    form: ALForm;
  };
}

export default baseMixins
  .extend<Options>({
    functional: false
  })
  .extend({
    name: 'DocumentTagFormDialog',
    components: {
      ALDialog,
      ErrorAlert
    },

    data() {
      return {
        dialog: false,
        loading: false,
        isEdit: false,
        isFormValid: false,

        documentTagData: { tag: {} } as IQuoteDocumentTagData,

        error: null as ISystemError | null
      };
    },

    computed: {
      ...mapGetters({
        getQuoteDocumentTagById: 'document/getQuoteDocumentTagById'
      })
    },

    methods: {
      ...mapActions({
        createQuoteDocumentTag: 'document/createQuoteDocumentTag',
        updateQuoteDocumentTag: 'document/updateQuoteDocumentTag'
      }),

      resetFormValidation(): void {
        if (this.$refs.form) {
          return this.$refs.form.resetValidation();
        }
      },

      validateForm(): boolean {
        let valid = false;
        if (this.$refs.form) {
          valid = this.$refs.form.validate();
        }
        return valid;
      },

      open(document?: IQuoteDocumentTag) {
        this.clearErrors();
        this.resetFormValidation();
        this.isEdit = !!document;

        this.documentTagData = this.isEdit
          ? new QuoteDocumentTag(document!)
          : ({ tag: {} } as IQuoteDocumentTagData);

        this.dialog = true;
      },

      close() {
        this.dialog = false;
      },

      async save() {
        this.clearErrors();
        const valid = this.validateForm();

        if (valid) {
          let documentInstance: IQuoteDocumentTag | null = null;

          try {
            documentInstance = new QuoteDocumentTag(this.documentTagData);
          } catch (error) {
            if (SystemError.isSystemError(error)) {
              this.error = error;
            }
          }

          if (documentInstance != null) {
            this.loading = true;

            const saveAction = this.isEdit
              ? this.updateQuoteDocumentTag
              : this.createQuoteDocumentTag;

            let payload = documentInstance;

            if (this.isEdit) {
              payload = diffDeep(
                documentInstance,
                this.getQuoteDocumentTagById(documentInstance.id),
                true
              );
            }

            saveAction(payload)
              .then(() => {
                this.close();
              })
              .catch(error => {
                this.error = setErrorFromAxiosError(error);
              })
              .finally(() => (this.loading = false));
          }
        }
      },

      clearErrors() {
        this.error = null;
      }
    }
  });
